/* One fact of the drawer's "Detalles", set like the mockup's dates above it. */
.fact {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.row dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
}
